<template>
  <section class="section exports">
    <b-container>
      <b-row class="justify-content-center">
        <b-col cols="12" lg="10">
          <p class="exports__title heading-2">XD to Flutter</p>
          <h2 class="exports__subtitle sub-heading">What can you export?</h2>

          <div class="attributes">
            <div
              v-for="(item, i) in exportsList"
              :key="i"
              class="attributes__item"
            >
              <div class="attributes__item__icon">
                <img
                  :src="require(`../assets/images/icons/${item.image}@2x.png`)"
                  :alt="`${item.alt}`"
                  :aria-labelledby="`${item.title.replaceAll(' ', '-')}-desc`"
                />
              </div>
              <h3 :id="`${item.title.replaceAll(' ', '-')}-desc`" class="attributes__item__subtitle">{{ item.title }}</h3>
              <p class="attributes__item__description body-3">
                {{ item.description }}
              </p>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
  export default {
    name: "Exports",
    data: () => ({
      exportsList: [
        {
          title: "Responsive Layouts",
          description:
            "Export arboards or components that resize responsively",
          image: "icon-responsive",
          alt: "Elements being laid out on an XD art board",
        },
        {
          title: "Prototype Interactions",
          description:
            "Wire navigation interactions visually in XD & export them to Flutter",
          image: "icon-prototype",
          alt: "cursor interacting with a gradient filled circle"
        },
        {
          title: "Assets",
          description: "Colors, character styles, & resolution-aware images",
          image: "icon-assets",
          alt: "Cursor interacting with element"
        },
        {
          title: "Rich Text",
          description:
            "Easily add rich, multi-format text to your Flutter app",
          image: "icon-text",
          alt: "Typography, capital letter A and lower case letter a"
        },
        {
          title: "Vector Graphics",
          description: "Rectangles, ellipses, custom shapes, gradients",
          image: "icon-vector",
          alt: "calligraphy cursor creating a vector arc"
        },
        {
          title: "& a whole lot more!",
          description: "Blend modes, shadows, blur, opacity, etc",
          image: "icon-blendModes",
          alt: "Square box half filled"
        },
      ],
    }),
  };
</script>

<style scoped lang="scss">
  @import "../variables";

  .exports {
    text-align: center;
    &__title {
      color: $body-3;
      margin-bottom: pxToRem(16);
    }
    &__subtitle {
      color: $title;
      margin-bottom: pxToRem(64);
    }

    .attributes {
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      margin-bottom: pxToRem(96);

      &__item {
        display: flex;
        flex-direction: column;
        max-width: 65%;
        text-align: left;
        margin-bottom: pxToRem(60);

        @media (min-width: 576px) {
          max-width: 40%;
          margin-bottom: unset;
        }
        @media (min-width: 768px) {
          max-width: 27%;
          padding: 0 pxToRem(24);
        }

        &__icon {
          display: flex;
          justify-content: center;

          img {
            object-fit: contain;
            object-position: left;
            padding: pxToRem(16) 0;
          }

          @media (min-width: 576px) {
            height: 104px;
            justify-content: unset;
          }
        }

        &__title {
          font-size: 64px;
          font-weight: 600;
          color: $accent;
        }
        &__subtitle {
          font-size: 18px;
          line-height: 24px;
          font-weight: 600;
          // Medium devices (tablets, 768px and up)
          @media (min-width: 768px) {
            font-size: 14px;
            line-height: 19px;
            letter-spacing: -0.2px;
          }
        }
      }
    }
  }
</style>
